import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function Register() {
  const { register, user } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created. Welcome to GameEdge.");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail ?? "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-6" data-testid="register-page">
      <div className="w-full max-w-md iso-card p-8">
        <Logo to="/" size={26} testid="register-logo-link" />
        <h1 className="mt-6 font-lexend">Create your account</h1>
        <p className="mt-1 text-sm text-gray-500">Start tracking bets, running simulations, and building legacy score.</p>

        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="register-form">
          <div>
            <label className="iso-label">Full name</label>
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="iso-input" data-testid="register-name" required />
          </div>
          <div>
            <label className="iso-label">Email</label>
            <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="iso-input" data-testid="register-email" required />
          </div>
          <div>
            <label className="iso-label">Password <span className="font-normal normal-case text-gray-400">(min 6 chars)</span></label>
            <input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="iso-input" data-testid="register-password" required minLength={6} />
          </div>
          <button disabled={busy} className="iso-btn-primary w-full" data-testid="register-submit">
            {busy && <Loader2 className="size-4 animate-spin" />}
            Create account
          </button>
        </form>
        <div className="mt-4 text-center text-sm text-gray-500">
          Already have one?{" "}
          <Link to="/login" className="font-semibold text-secondary hover:underline" data-testid="go-login-link">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
